(function(){
  'use strict';
  function init(){
    var area=document.querySelector('.fmy-offer-description');
    if(!area||!document.body.classList.contains('fmy-offer-page'))return;
    area.querySelectorAll('.fmy-offer-story img').forEach(function(img){
      if(img.closest('a,button'))return;
      var raw=img.getAttribute('src');if(!raw)return;
      var original=new URL(raw,location.href);original.searchParams.delete('width');original.searchParams.delete('height');
      var link=document.createElement('a');link.className='fmy-offer-detail-image';link.href=original.href;
      link.setAttribute('data-no-instant','');link.setAttribute('data-t4s-image-opend','');link.setAttribute('data-pswp-src',original.href);
      link.setAttribute('data-pswp-w',img.getAttribute('width')||'1254');link.setAttribute('data-pswp-h',img.getAttribute('height')||'1254');
      link.setAttribute('aria-label','Ampliar imagem: '+(img.alt||'detalhes da oferta'));
      img.parentNode.insertBefore(link,img);link.appendChild(img);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
